import { createHooksActions, createHooksSelectors } from 'src/helpers/redux'
import * as store from 'src/store/modules/numbers'

store.injectStore()
export { store }

export const useNumbersSelect = createHooksSelectors<
  typeof store.selectors.selectors
>(store.selectors.selectors)

export const useNumbersActions = createHooksActions<typeof store.actions>(
  store.actions,
  store.selectors.communications
)
